/* Sticker Cartel — packaging builder */
(function () {
  var root = document.querySelector('[data-wizard]');
  if (!root) return;
  var cfg; try { cfg = JSON.parse(root.querySelector('[data-wizard-config]').textContent); } catch (e) { return; }

  var panel = root.querySelector('[data-wiz-panel]');
  var screen = root.querySelector('[data-wiz-screen]');
  var stepline = root.querySelector('[data-wiz-stepline]');
  var running = root.querySelector('[data-wiz-running]');
  var bar = root.querySelector('[data-wiz-bar]');
  var cheer = root.querySelector('[data-wiz-cheer]');
  var backBtn = root.querySelector('[data-wiz-back]');
  var nextBtn = root.querySelector('[data-wiz-next]');
  var footNote = root.querySelector('[data-wiz-foot]');
  var money = function (c) { return '$' + (c / 100).toFixed(2); };

  function pairs(text) {
    var out = {};
    (text || '').split('\n').forEach(function (l) { var b = l.split('='); if (b.length === 2) out[b[0].trim()] = b[1].trim(); });
    return out;
  }
  var groups = pairs(cfg.sizeGroups), notes = pairs(cfg.sizeNotes);
  var minimums = {};
  (cfg.minimums || '').split(',').forEach(function (p) { var b = p.split(':'); if (b.length === 2) minimums[b[0].trim().toLowerCase()] = parseInt(b[1], 10) || 1; });
  var colors = (cfg.colors || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean);
  var tierMin = function (l) { var m = String(l).match(/(\d+)/); return m ? parseInt(m[1], 10) : 1; };
  var oi = function (p, n) { return p.options.indexOf(n); };

  var fresh = function () {
    return { size: null, qty: null, designs: 1, material: 'Matte', finish: 'No finish', sides: 'Front and back',
             color: null, designName: '', note: '', qr: '', front: null, back: null, later: false, seals: false, addon: false };
  };
  var state = fresh(), line = null, step = 0, queued = [];

  /* ---------- pricing ---------- */
  function baseVariant() {
    if (line === 'trays') return cfg.trays ? { id: cfg.trays.id, price: cfg.trays.price } : null;
    var p = line === 'bags' ? cfg.bags : cfg.bottles; if (!p) return null;
    var qi = oi(p, 'Quantity');
    var pool = p.variants.filter(function (v) {
      if (line === 'bags') return v.options[oi(p, 'Size')] === state.size;
      return v.options[oi(p, 'Seals')] === (state.seals ? 'With seals' : 'No seals');
    });
    var best = null;
    pool.forEach(function (v) { var m = tierMin(v.options[qi]); if ((state.qty || 0) >= m && (!best || m > tierMin(best.options[qi]))) best = v; });
    if (!best && pool.length) best = pool.reduce(function (a, b) { return tierMin(a.options[qi]) <= tierMin(b.options[qi]) ? a : b; });
    return best;
  }
  function upgradeVariant(kind) {
    var p = cfg.upgrades; if (!p || line !== 'bags') return null;
    var g = groups[state.size]; if (!g) return null;
    return p.variants.filter(function (v) { return v.options[oi(p, 'Upgrade')] === kind && v.options[oi(p, 'Bag')] === g; })[0] || null;
  }
  function upgradePrice(kind) { var v = upgradeVariant(kind); return v ? v.price : 0; }
  function activeUpgrades() {
    var list = [];
    if (line !== 'bags') return list;
    if (state.material === 'Holographic') list.push('Holographic');
    if (state.finish === 'Gloss varnish') list.push('Gloss varnish');
    if (state.finish === 'Embossing') list.push('Embossing');
    return list;
  }
  function unit() {
    var b = baseVariant(); var u = b ? b.price : 0;
    activeUpgrades().forEach(function (k) { u += upgradePrice(k); });
    return u;
  }
  function total() { return unit() * (state.qty || 0); }
  function minFor() {
    var key = line === 'bags' ? (state.size || '').toLowerCase() : (line === 'bottles' ? 'pill bottles' : 'led rolling trays');
    return minimums[key] || 1;
  }
  function tiers() {
    var p = line === 'bags' ? cfg.bags : cfg.bottles; if (!p) return [];
    var qi = oi(p, 'Quantity'), seen = {}, out = [];
    p.variants.forEach(function (v) {
      if (line === 'bags' && v.options[oi(p, 'Size')] !== state.size) return;
      if (line === 'bottles' && v.options[oi(p, 'Seals')] !== (state.seals ? 'With seals' : 'No seals')) return;
      var l = v.options[qi]; if (seen[l]) return; seen[l] = 1; out.push({ label: l, min: tierMin(l), price: v.price });
    });
    return out.sort(function (a, b) { return a.min - b.min; });
  }
  function unitAt(q) { var k = state.qty; state.qty = q; var u = unit(); state.qty = k; return u; }
  function discountVsBase() {
    var t = tiers(); if (!t.length) return 0;
    var top = t[0].price; var now = (baseVariant() || {}).price || top;
    return top ? Math.round((1 - now / top) * 100) : 0;
  }

  /* ---------- flow ---------- */
  function flow() {
    if (line === 'bags') return ['size', 'qty', 'designs', 'material', 'finish', 'sides', 'artwork', 'color', 'more', 'review'];
    if (line === 'bottles') return ['qty', 'seals', 'artwork', 'color', 'more', 'review'];
    if (line === 'trays') return ['qty', 'artwork', 'more', 'review'];
    return [];
  }
  var titles = { size: 'Size', qty: 'How many', designs: 'Designs', material: 'Material', finish: 'Finish', sides: 'Sides',
                 artwork: 'Artwork', color: 'Color', seals: 'Seals', more: 'Anything else', review: 'Review' };

  /* ---------- ui helpers ---------- */
  function head(title, sub, hint) {
    var h = document.createElement('div'); h.className = 'wiz-head';
    var t = document.createElement('h2'); t.className = 'h-3'; t.textContent = title; h.appendChild(t);
    if (sub) { var s = document.createElement('p'); s.className = 'muted mt-3'; s.textContent = sub; h.appendChild(s); }
    if (hint) { var p = document.createElement('p'); p.className = 'wiz-hint mt-3'; p.textContent = hint; h.appendChild(p); }
    return h;
  }
  function list() { var d = document.createElement('div'); d.className = 'wiz-list'; return d; }
  function opt(o) {
    var b = document.createElement('button'); b.type = 'button';
    b.className = 'wiz-opt' + (o.on ? ' is-on' : '');
    var main = document.createElement('span'); main.className = 'wiz-opt__main';
    var t = document.createElement('span'); t.className = 'wiz-opt__title'; t.textContent = o.title; main.appendChild(t);
    if (o.sub) { var s = document.createElement('span'); s.className = 'wiz-opt__sub'; s.textContent = o.sub; main.appendChild(s); }
    var right = document.createElement('span'); right.className = 'wiz-opt__right';
    if (o.tag) { var g = document.createElement('span'); g.className = 'wiz-tag'; g.textContent = o.tag; right.appendChild(g); }
    if (o.on) { var c = document.createElement('span'); c.className = 'wiz-check'; c.textContent = '✓'; right.appendChild(c); }
    b.appendChild(main); b.appendChild(right);
    b.addEventListener('click', o.onClick);
    return b;
  }
  function swatch(name) {
    var map = { White: '#f5f3ee', Cream: '#efe4c8', Tan: '#d8b98a', Brown: '#6b4428', Grey: '#9aa0a6', Black: '#17181a', Red: '#c9282d',
      Maroon: '#77192a', Orange: '#e4791f', Mustard: '#d8a72a', Yellow: '#efd23c', 'Army Green': '#5e6b34', Green: '#3f9d52',
      'Pine Green': '#245c3c', Turquoise: '#41bfc4', 'Ice Blue': '#cbe5f2', 'Baby Blue': '#8ec7e8', Blue: '#1f56c4',
      'Light Purple': '#b492e0', 'Royal Purple': '#7723c4', 'Deep Purple': '#3d1866', 'Light Pink': '#f3b9cf', 'Hot Pink': '#e8408f' };
    return map[name] || 'conic-gradient(from 0deg,#e8322f,#efd23c,#3f9d52,#1f56c4,#7723c4,#e8322f)';
  }
  var noun = function () { return line === 'bags' ? 'bags' : (line === 'bottles' ? 'bottles' : 'trays'); };

  /* ---------- render ---------- */
  function render() {
    var f = flow(), key = f[step];
    screen.innerHTML = '';
    nextBtn.hidden = false; nextBtn.disabled = false; footNote.textContent = '';
    backBtn.hidden = step === 0 && !queued.length;
    stepline.textContent = 'Step ' + (step + 1) + ' of ' + f.length + ' · ' + (titles[key] || '').toUpperCase();
    var pct = step / (f.length - 1);
    bar.style.width = (pct * 100) + '%';
    cheer.textContent = pct >= 0.8 ? 'Almost there' : (pct >= 0.45 ? 'Halfway there' : '');
    running.textContent = state.qty ? (state.qty + ' ' + noun() + ' · ' + money(total())) : '';

    if (key === 'size') {
      screen.appendChild(head('What size ' + (line === 'bags' ? 'mylar bag' : 'item') + ' do you need?', 'Not sure? The 8th is our most ordered.'));
      var p = cfg.bags, si = oi(p, 'Size'), seen = {}, l = list();
      p.variants.forEach(function (v) {
        var s = v.options[si]; if (seen[s]) return; seen[s] = 1;
        var m = minimums[s.toLowerCase()] || 1;
        l.appendChild(opt({ title: s, sub: (notes[s] ? notes[s] + ' ' : '') + 'Min order is ' + m + ' bag' + (m === 1 ? '' : 's'),
          on: state.size === s, onClick: function () { state.size = s; state.qty = null; render(); } }));
      });
      screen.appendChild(l);
      nextBtn.textContent = state.size ? 'Keep ' + state.size.split(' (')[0] : 'Continue';
      nextBtn.disabled = !state.size;
    }

    if (key === 'qty') {
      var min = minFor();
      if (!state.qty) state.qty = min;
      var d = discountVsBase();
      screen.appendChild(head('How many ' + noun() + ' in total?',
        'We picked ' + state.qty + (d ? ' — a great deal at ' + d + '% off.' : '.') + ' Change it to anything you like.'));
      if (line !== 'trays') {
        var chips = document.createElement('div'); chips.className = 'wiz-chips';
        var ts = tiers(), top = ts.length ? ts[0].price : 0;
        ts.forEach(function (t) {
          var cur = state.qty >= t.min && !ts.some(function (x) { return x.min > t.min && state.qty >= x.min; });
          var off = top ? Math.round((1 - t.price / top) * 100) : 0;
          var b = document.createElement('button'); b.type = 'button'; b.className = 'wiz-chip' + (cur ? ' is-on' : '');
          var n = document.createElement('span'); n.className = 'wiz-chip__n'; n.textContent = t.min;
          var s2 = document.createElement('span'); s2.className = 'wiz-chip__p'; s2.textContent = off ? off + '% off' : 'minimum';
          b.appendChild(n); b.appendChild(s2);
          b.addEventListener('click', function () { state.qty = Math.max(t.min, min); render(); });
          chips.appendChild(b);
        });
        screen.appendChild(chips);
      }
      var st = document.createElement('div'); st.className = 'wiz-stepper';
      st.innerHTML = '<button type="button" data-d="-1">−</button><input type="number" inputmode="numeric"><button type="button" data-d="1">+</button>';
      var input = st.querySelector('input'); input.value = state.qty; input.min = min;
      input.addEventListener('input', function () { state.qty = Math.max(0, parseInt(input.value, 10) || 0); live(); });
      st.addEventListener('click', function (e) {
        var b = e.target.closest('[data-d]'); if (!b) return;
        var inc = (line === 'bags' && state.size && state.size.indexOf('QP/LB') === 0) || line === 'trays' ? 1 : 8;
        state.qty = Math.max(min, state.qty + inc * parseInt(b.dataset.d, 10)); render();
      });
      screen.appendChild(st);
      var box = document.createElement('div'); box.className = 'wiz-price box mt-6';
      box.innerHTML = '<p class="wiz-price__line"></p><p class="wiz-price__sub"></p>';
      screen.appendChild(box); live();
      nextBtn.textContent = 'Continue';
    }

    if (key === 'designs') {
      screen.appendChild(head('How many different designs on these bags?', 'One design, or a few different ones — your call. You can change the amounts later.'));
      var l2 = list();
      [1, 2, 3, 4].forEach(function (n) {
        var per = Math.floor(state.qty / n), rem = state.qty - per * n, sp = [];
        for (var i = 0; i < n; i++) sp.push(per + (i < rem ? 1 : 0));
        l2.appendChild(opt({ title: n === 1 ? 'Just one design' : n + ' designs',
          sub: n === 1 ? 'All ' + state.qty + ' bags with one design' : sp.join(' + ') + ' bags',
          on: state.designs === n, onClick: function () { state.designs = n; render(); } }));
      });
      l2.appendChild(opt({ title: 'More than 4', sub: 'Tell us the exact number in your note.', on: state.designs > 4,
        onClick: function () { state.designs = 5; render(); } }));
      screen.appendChild(l2);
      nextBtn.textContent = 'Keep ' + (state.designs > 4 ? '5+ designs' : state.designs + (state.designs === 1 ? ' design' : ' designs'));
    }

    if (key === 'material') {
      screen.appendChild(head('Matte or holographic?', null, 'Prices show what each choice adds to all ' + state.qty + ' bags.'));
      var l3 = list();
      [['Matte', 'Smooth, classic, no shine.', 0], ['Holographic', 'Rainbow shine that moves in the light.', upgradePrice('Holographic')]].forEach(function (r) {
        l3.appendChild(opt({ title: r[0], sub: r[1], tag: r[2] ? '+' + money(r[2] * state.qty) : null, on: state.material === r[0],
          onClick: function () { state.material = r[0]; render(); } }));
      });
      screen.appendChild(l3);
      nextBtn.textContent = 'Keep ' + state.material;
    }

    if (key === 'finish') {
      screen.appendChild(head('Want a special finish?', 'These make parts of your design shiny or raised.',
        'Prices show what each choice adds to all ' + state.qty + ' bags.'));
      var l4 = list();
      [['No finish', 'Clean print, best price. You can add finishes on a reorder.', 0],
       ['Gloss varnish', 'Shiny, wet-look highlights on parts of your design.', upgradePrice('Gloss varnish')],
       ['Embossing', 'Raised parts you can feel with your fingers.', upgradePrice('Embossing')]].forEach(function (r) {
        l4.appendChild(opt({ title: r[0], sub: r[1], tag: r[2] ? '+' + money(r[2] * state.qty) : null, on: state.finish === r[0],
          onClick: function () { state.finish = r[0]; render(); } }));
      });
      screen.appendChild(l4);
      nextBtn.textContent = state.finish === 'No finish' ? 'Continue' : 'Keep ' + state.finish;
    }

    if (key === 'sides') {
      screen.appendChild(head('Print one side or both?', 'Same price either way — it tells us how many files to expect.'));
      var l5 = list();
      [['Front and back', "You'll add a second file."], ['Front only', 'Back stays plain.']].forEach(function (r) {
        l5.appendChild(opt({ title: r[0], sub: r[1], on: state.sides === r[0], onClick: function () { state.sides = r[0]; render(); } }));
      });
      screen.appendChild(l5);
      nextBtn.textContent = 'Keep ' + state.sides.toLowerCase();
    }

    if (key === 'seals') {
      screen.appendChild(head('Add induction seals?', null, 'Prices show what each choice adds to all ' + state.qty + ' bottles.'));
      var l6 = list(), plainP = (function () { var k = state.seals; state.seals = false; var u = unit(); state.seals = k; return u; })();
      [[false, 'No seals', 'Bottles and labels only.'], [true, 'With seals', 'Tamper-evident seal on every bottle.']].forEach(function (r) {
        var k = state.seals; state.seals = r[0]; var u = unit(); state.seals = k;
        l6.appendChild(opt({ title: r[1], sub: r[2], tag: r[0] ? '+' + money((u - plainP) * state.qty) : null, on: state.seals === r[0],
          onClick: function () { state.seals = r[0]; render(); } }));
      });
      screen.appendChild(l6);
      nextBtn.textContent = 'Continue';
    }

    if (key === 'artwork') {
      screen.appendChild(head('Add your design', 'Upload print-ready art. Not just a logo.'));
      var hint = document.createElement('p'); hint.className = 'text-center';
      hint.innerHTML = 'No design yet? <a class="link-accent" href="' + cfg.designLink + '">We can design it for you</a>';
      screen.appendChild(hint);
      var wrap = document.createElement('div'); wrap.className = 'wiz-art';
      wrap.innerHTML =
        '<div class="wiz-art__row">' +
          '<input class="input" data-design placeholder="Design name (optional)">' +
          '<button type="button" class="btn-ghost" data-note-toggle>+ Add note</button>' +
        '</div>' +
        '<textarea class="textarea mt-3" rows="3" data-note placeholder="Anything we should know — deadline, design split, colors" hidden></textarea>' +
        '<div class="wiz-drops">' +
          '<label class="wiz-drop"><span class="wiz-drop__label">FRONT</span><span class="wiz-drop__cta">Tap to upload</span>' +
          '<span class="wiz-drop__types">PNG, JPG, PDF or AI</span><input type="file" data-front accept=".png,.jpg,.jpeg,.pdf,.ai,.svg" hidden></label>' +
          '<label class="wiz-drop" data-back-drop><span class="wiz-drop__label">BACK</span><span class="wiz-drop__cta">Tap to upload</span>' +
          '<span class="wiz-drop__types">PNG, JPG, PDF or AI</span><input type="file" data-back accept=".png,.jpg,.jpeg,.pdf,.ai,.svg" hidden></label>' +
        '</div>' +
        '<button type="button" class="wiz-later" data-later>No files yet? Send them after checkout</button>' +
        '<details class="wiz-qr"><summary>QR code <span class="wiz-tag">optional</span></summary>' +
          '<input class="input mt-3" data-qr placeholder="Link for the QR code (menu, IG, site)"></details>';
      screen.appendChild(wrap);
      var dn = wrap.querySelector('[data-design]'), nt = wrap.querySelector('[data-note]'), qr = wrap.querySelector('[data-qr]');
      dn.value = state.designName; nt.value = state.note; qr.value = state.qr;
      if (state.note) nt.hidden = false;
      dn.addEventListener('input', function () { state.designName = dn.value; });
      nt.addEventListener('input', function () { state.note = nt.value; });
      qr.addEventListener('input', function () { state.qr = qr.value; });
      wrap.querySelector('[data-note-toggle]').addEventListener('click', function () { nt.hidden = !nt.hidden; if (!nt.hidden) nt.focus(); });
      if (line === 'bags' && state.sides === 'Front only') wrap.querySelector('[data-back-drop]').style.display = 'none';
      ['front', 'back'].forEach(function (sideKey) {
        var inp = wrap.querySelector('[data-' + sideKey + ']');
        if (!inp) return;
        var label = inp.closest('.wiz-drop');
        if (state[sideKey]) { label.classList.add('is-filled'); label.querySelector('.wiz-drop__cta').textContent = state[sideKey].name; }
        inp.addEventListener('change', function () {
          var file = inp.files[0]; if (!file) return;
          if (file.size > 20 * 1024 * 1024) { label.querySelector('.wiz-drop__types').textContent = 'That file is over 20MB — email it instead.'; return; }
          state[sideKey] = file; state.later = false;
          label.classList.add('is-filled'); label.querySelector('.wiz-drop__cta').textContent = file.name;
          render();
        });
      });
      var later = wrap.querySelector('[data-later]');
      if (state.later) later.classList.add('is-on');
      later.addEventListener('click', function () { state.later = !state.later; state.front = null; state.back = null; render(); });
      nextBtn.textContent = 'Continue';
    }

    if (key === 'color') {
      screen.appendChild(head('Pick your ' + (line === 'bottles' ? 'bottle' : 'bag') + ' color', 'Your artwork prints on top of this color.'));
      var grid = document.createElement('div'); grid.className = 'wiz-colors';
      colors.forEach(function (c) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'wiz-color' + (state.color === c ? ' is-on' : '');
        var dot = document.createElement('span'); dot.className = 'wiz-color__dot'; dot.style.background = swatch(c);
        var lb = document.createElement('span'); lb.className = 'wiz-color__label'; lb.textContent = c;
        b.appendChild(dot); b.appendChild(lb);
        b.addEventListener('click', function () { state.color = c; render(); });
        grid.appendChild(b);
      });
      screen.appendChild(grid);
      nextBtn.disabled = !state.color;
      nextBtn.textContent = 'Continue';
      if (!state.color) footNote.textContent = 'Pick an option above to continue';
    }

    if (key === 'more') {
      var ts2 = tiers(), nt2 = ts2.filter(function (t) { return t.min > state.qty; })[0];
      var sum = 'All set: ' + state.qty + ' ' + noun() + (line === 'bags' ? ' across ' + (state.designs > 4 ? '5+' : state.designs) + ' design' + (state.designs === 1 ? '' : 's') : '') + '.';
      if (nt2) sum += ' Add ' + (nt2.min - state.qty) + ' more and every one drops to ' + money(unitAt(nt2.min)) + ' each.';
      screen.appendChild(head('Anything else?', sum));
      var l7 = list();
      l7.appendChild(opt({ title: "That's everything", sub: 'Take me to my order.', on: !state.addon, onClick: function () { state.addon = false; step++; render(); } }));
      l7.appendChild(opt({ title: 'Add more to this order', sub: 'Another design, or a different bag.', onClick: function () { stash(true); } }));
      if (line === 'bags' && state.size && state.size.indexOf('QP/LB') !== 0) {
        var pound = (cfg.bags.variants.filter(function (v) { return v.options[oi(cfg.bags, 'Size')] === 'QP/LB (13x15)'; })[0] || {}).price || 0;
        l7.appendChild(opt({ title: 'Add a matching pound bag', sub: 'Same design and finish · QP/LB (13x15)',
          tag: '+' + money(pound * cfg.addonQty), on: state.addon, onClick: function () { state.addon = !state.addon; render(); } }));
      }
      screen.appendChild(l7);
      nextBtn.textContent = 'Continue';
    }

    if (key === 'review') {
      screen.appendChild(head('Here it is', 'Check it over, then add it to your cart.'));
      var rows = [];
      if (line === 'bags') rows.push(['Bag', state.size]);
      if (line === 'bottles') rows.push(['Product', 'Pill bottles']);
      if (line === 'trays') rows.push(['Product', 'LED rolling trays']);
      rows.push(['Quantity', state.qty + ' ' + noun()]);
      if (line === 'bags') {
        rows.push(['Designs', state.designs > 4 ? '5 or more' : state.designs]);
        rows.push(['Material', state.material]);
        rows.push(['Finish', state.finish]);
        rows.push(['Sides', state.sides]);
      }
      if (line === 'bottles') rows.push(['Seals', state.seals ? 'Yes' : 'No']);
      if (state.color) rows.push(['Color', state.color]);
      rows.push(['Artwork', state.front ? (state.front.name + (state.back ? ' + ' + state.back.name : '')) : (state.later ? 'Sending after checkout' : 'None attached')]);
      if (state.designName) rows.push(['Design name', state.designName]);
      if (state.qr) rows.push(['QR code', state.qr]);
      if (state.note) rows.push(['Note', state.note]);
      if (state.addon) rows.push(['Add-on', cfg.addonQty + ' matching pound bag' + (cfg.addonQty === 1 ? '' : 's')]);
      if (queued.length) rows.push(['Also in this order', queued.length + ' more item' + (queued.length === 1 ? '' : 's')]);
      var tbl = document.createElement('div'); tbl.className = 'wiz-review';
      rows.forEach(function (r) {
        var d = document.createElement('div'); d.className = 'wiz-review__row';
        var a = document.createElement('span'); a.className = 'mono-label'; a.textContent = r[0];
        var b = document.createElement('span'); b.textContent = r[1];
        d.appendChild(a); d.appendChild(b); tbl.appendChild(d);
      });
      screen.appendChild(tbl);
      var tot = document.createElement('div'); tot.className = 'box box--accent mt-6';
      tot.innerHTML = '<div class="estimate"><div><p class="mono-label">Your total</p><p class="small muted mt-1"></p></div><p class="estimate__total"></p></div>';
      tot.querySelector('.small').textContent = state.qty + ' × ' + money(unit()) + ' each' + (state.addon ? ' + pound bag' : '');
      tot.querySelector('.estimate__total').textContent = money(grandTotal());
      screen.appendChild(tot);
      var msg = document.createElement('p'); msg.className = 'small mt-3'; msg.setAttribute('data-wiz-msg', '');
      screen.appendChild(msg);
      nextBtn.textContent = 'Add to cart · ' + money(grandTotal());
    }
  }

  function addonPrice() {
    if (!state.addon || !cfg.bags) return 0;
    var v = cfg.bags.variants.filter(function (x) { return x.options[oi(cfg.bags, 'Size')] === 'QP/LB (13x15)'; })[0];
    return v ? v.price * cfg.addonQty : 0;
  }
  function grandTotal() {
    var t = total() + addonPrice();
    queued.forEach(function (q) { t += q.total; });
    return t;
  }
  function live() {
    var min = minFor(), box = screen.querySelector('.wiz-price');
    if (box) {
      box.querySelector('.wiz-price__line').innerHTML = 'About <strong>' + money(unit()) + ' per ' + noun().slice(0, -1) + '</strong> · ' + money(total()) + ' for ' + state.qty + '.';
      var d = discountVsBase();
      var nt = tiers().filter(function (t) { return t.min > state.qty; })[0];
      box.querySelector('.wiz-price__sub').textContent = nt
        ? 'Add ' + (nt.min - state.qty) + ' more to drop to ' + money(unitAt(nt.min)) + ' each.'
        : (d ? d + '% volume discount already taken off.' : '');
    }
    running.textContent = state.qty ? (state.qty + ' ' + noun() + ' · ' + money(total())) : '';
    nextBtn.disabled = state.qty < min;
    footNote.textContent = state.qty < min ? 'Minimum order is ' + min + '.' : '';
  }

  /* ---------- cart ---------- */
  function itemsFor(s, ln) {
    var keep = state, keepLine = line; state = s; line = ln;
    var out = [], b = baseVariant();
    var props = {};
    if (ln === 'bags') { props['Designs'] = s.designs > 4 ? '5 or more' : String(s.designs); props['Sides'] = s.sides; props['Material'] = s.material; props['Finish'] = s.finish; }
    if (ln === 'bottles') props['Seals'] = s.seals ? 'Yes' : 'No';
    if (s.color) props['Color'] = s.color;
    if (s.designName) props['Design name'] = s.designName;
    if (s.qr) props['QR code'] = s.qr;
    if (s.note) props['Note'] = s.note;
    if (!s.front && s.later) props['Artwork'] = 'Sending after checkout';
    if (b) out.push({ id: b.id, quantity: s.qty, properties: props, files: { 'Artwork front': s.front, 'Artwork back': s.back } });
    activeUpgrades().forEach(function (k) {
      var v = upgradeVariant(k);
      if (v) out.push({ id: v.id, quantity: s.qty, properties: { 'For': (s.designName || s.size || 'your order') } });
    });
    if (s.addon) {
      var pv = cfg.bags.variants.filter(function (x) { return x.options[oi(cfg.bags, 'Size')] === 'QP/LB (13x15)'; })[0];
      if (pv) out.push({ id: pv.id, quantity: cfg.addonQty, properties: { 'Matching add-on': 'Same design & finish', 'Color': s.color || '' } });
    }
    state = keep; line = keepLine;
    return out;
  }

  function postItem(item) {
    var fd = new FormData();
    fd.append('id', item.id);
    fd.append('quantity', item.quantity);
    Object.keys(item.properties || {}).forEach(function (k) { if (item.properties[k]) fd.append('properties[' + k + ']', item.properties[k]); });
    Object.keys(item.files || {}).forEach(function (k) { if (item.files[k]) fd.append('properties[' + k + ']', item.files[k]); });
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); }); return r.json(); });
  }

  function addAll() {
    var msg = screen.querySelector('[data-wiz-msg]');
    nextBtn.disabled = true; nextBtn.textContent = 'Adding…';
    var all = [];
    queued.forEach(function (q) { all = all.concat(q.items); });
    all = all.concat(itemsFor(state, line));
    var chain = Promise.resolve();
    all.forEach(function (it) { chain = chain.then(function () { return postItem(it); }); });
    chain.then(function () { window.location.href = '/cart'; })
      .catch(function (e) {
        if (msg) { msg.textContent = e.message + '. Try again, or send files by email after checkout.'; msg.style.color = 'var(--destructive)'; }
        nextBtn.disabled = false; nextBtn.textContent = 'Add to cart · ' + money(grandTotal());
      });
  }

  function stash(restart) {
    queued.push({ items: itemsFor(state, line), total: total() + addonPrice(), label: (state.size || noun()) });
    var qty = state.qty, size = state.size, color = state.color;
    state = fresh();
    state.qty = qty; state.size = size; state.color = color;
    step = 0; render();
    screen.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* ---------- start ---------- */
  function start(which) {
    if (['bags', 'bottles', 'trays'].indexOf(which) < 0) return;
    line = which; state = fresh(); step = 0; queued = [];
    panel.hidden = false;
    render();
    panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="start="]');
    if (!a) return;
    var m = a.getAttribute('href').match(/start=(bags|bottles|trays)/);
    if (!m) return;
    if (a.pathname && window.location.pathname !== a.pathname) return;
    e.preventDefault();
    history.replaceState({}, '', a.getAttribute('href'));
    start(m[1]);
  });
  nextBtn.addEventListener('click', function () {
    var f = flow();
    if (f[step] === 'review') { addAll(); return; }
    if (step < f.length - 1) { step++; render(); panel.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
  backBtn.addEventListener('click', function () { if (step > 0) { step--; render(); } });

  var qs = new URLSearchParams(window.location.search).get('start');
  if (qs) start(qs);
})();
